/**
 * Avgör om ett fel från `supabase.auth.getUser()` betyder att sessionen är
 * återkallad på servern — användaren raderad/bannad eller token ogiltiggjord —
 * och att den lokalt cachade sessionen därför ska rensas.
 *
 * Endast ett explicit avvisande från auth-servern (AuthApiError med 401/403)
 * räknas. Nätverksfel och andra transienta fel (t.ex. AuthRetryableFetchError
 * när PWA:n är offline) får aldrig logga ut användaren.
 */
export function isSessionRevokedError(
  error: { name?: string; status?: number } | null | undefined
): boolean {
  if (!error) return false;
  return error.name === 'AuthApiError' && (error.status === 401 || error.status === 403);
}
